/* eslint-disable no-empty */
/* eslint-disable no-useless-catch */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable no-undef */
(function () {
  if (window.hcJsBridge) {
    return;
  }

  window.hcJsBridge = {
    callHandler,
    registerHandler,
    handleMessageFromNative,
    messageHandlers: {},
    messageCallbacks: {},
  };
  let uniqueId = 1;

  function callHandler(name, data, responseCallback) {
    if (arguments.length === 2 && typeof data === 'function') {
      responseCallback = data;
      data = null;
    }
    const message = { name, data };
    if (responseCallback) {
      const callbackId = `cb_${uniqueId++}_${new Date().getTime()}`;
      message.callbackId = callbackId;
      hcJsBridge.messageCallbacks[callbackId] = responseCallback;
    }
    const messageJson = JSON.stringify(message);
    if (typeof nativeBridgeHead === 'undefined') {
      try {
        window.webkit.messageHandlers.handleMessage.postMessage(messageJson);
      } catch (e) {
        throw e;
      }
    } else {
      nativeBridgeHead.handleMessage(messageJson);
    }
  }

  function registerHandler(name, handler) {
    hcJsBridge.messageHandlers[name] = handler;
  }

  function handleMessageFromNative(messageJSON) {
    let message = messageJSON;
    if (typeof message !== 'object') {
      message = JSON.parse(unescape(messageJSON));
    }
    const { responseId } = message;
    if (responseId) {
      const { responseData } = message;
      const callback = hcJsBridge.messageCallbacks[responseId];
      callback(responseData);
    } else {
      const messageName = message.name;
      const messageData = message.data;
      const messageCallbackId = message.callbackId;

      const handler = hcJsBridge.messageHandlers[messageName];
      const responseCallback = function (data) {
        const responseMessage = {
          responseId: messageCallbackId,
          responseData: data,
          stateCode: 0,
        };
        const responseMessageJson = JSON.stringify(responseMessage);
        if (typeof nativeBridgeHead === 'undefined') {
          window.webkit.messageHandlers.handleResponseMessage.postMessage(
            responseMessageJson,
          );
        } else {
          nativeBridgeHead.handleResponseMessage(responseMessageJson);
        }
      };
      handler(messageData, responseCallback);
    }
  }

  setTimeout(function () {
    if (typeof nativeBridgeHead === 'undefined') {
      try {
        window.webkit.messageHandlers.handleStartupMessage.postMessage('');
      } catch (e) {}
    } else {
      nativeBridgeHead.handleStartupMessage();
    }
  }, 0);
})();

export const NissanApi = {
  getAppUserInfo(callback = null) {
    hcJsBridge.callHandler('webkit.getAppUserInfo', function (response) {
      const res = JSON.parse(response);
      if (res.stateCode == '-1' || res.stateCode == -1) {
        layer.open({ content: res.msg, skin: 'msg', time: 2 });
        throw new Error(res.msg);
      }
      if (callback) {
        callback(res);
      }
    });
  },
  getAppUserToken(callback = null) {
    hcJsBridge.callHandler('webkit.getAppUserToken', function (response) {
      const res = JSON.parse(response);
      if (res.stateCode == '-1' || res.stateCode == -1) {
        layer.open({ content: res.msg, skin: 'msg', time: 2 });
        throw new Error(res.msg);
      }
      if (callback) {
        callback(res);
      }
    });
  },
  longUrl2ShortCode(postData = null, callback = null) {
    hcJsBridge.callHandler(
      'webkit.longUrl2ShortCode',
      postData,
      function (response) {
        const res = JSON.parse(response);
        if (res.stateCode == '-1' || res.stateCode == -1) {
          layer.open({ content: res.msg, skin: 'msg', time: 2 });
          throw new Error(res.msg);
        }
        if (callback) {
          callback(res);
        }
      },
    );
  },
  updateQueryStringParameter(uri, key, value) {
    if (!value) {
      return uri;
    }
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
      return uri.replace(re, `$1${key}=${value}$2`);
    }
    return `${uri + separator + key}=${value}`;
  },

  webViewJumpMiniProgram(postData = null, callback = null) {
    try {
      hcJsBridge.callHandler(
        'webkit.webViewJumpMiniProgram',
        postData,
        function (response) {
          if (callback) {
            callback(response);
          }
        },
      );
    } catch (r) {
      logError();
    }
  },

  getOS() {
    const ua = navigator.userAgent;
    if (ua.match(/iPhone|iPod/i) != null) {
      // iphone代码
      return 'iOS';
    }
    if (ua.match(/Android/i) != null) {
      // android代码
      return 'Android';
    }
    if (ua.match(/iPad/i) != null) {
      // ipad代码
      return 'iPad';
    }
    return 'pc';
  },

  webViewJumpApp(postData = null, callback = null) {
    try {
      hcJsBridge.callHandler(
        'webkit.webViewJumpApp',
        postData,
        function (response) {
          if (callback) {
            callback(response);
          }
        },
      );
    } catch (r) {
      console.log('请在app使用');
      if (callback) {
        callback();
      }
    }
  },

  jumpToModule(data, callback = null) {
    try {
      hcJsBridge.callHandler(
        'webkit.jumpToModule',
        data,
        function (response) {},
      );
    } catch (r) {
      console.log('请在app使用');
    }
  },

  setWebviewTitleBar(postData = null, callback = null) {
    try {
      hcJsBridge.callHandler(
        'webkit.setWebviewTitleBar',
        postData,
        function (response) {
          if (callback) {
            callback(response);
          }
        },
      );
    } catch (r) {
      console.log('请在app使用');
    }
  },

  setAppTitle(postData = null, callback = null) {
    try {
      hcJsBridge.callHandler('webkit.setAppTitle', postData);
    } catch (r) {
      document.title = postData;
      console.log('请在app使用');
    }
  },

  webSendPlayActivityParams(postData = null, callback = null) {
    try {
      hcJsBridge.callHandler('webkit.webSendPlayActivityParams', postData);
    } catch (r) {
      console.log('请在app使用');
    }
  },

  onPay(postData = null, callback = null) {
    try {
      hcJsBridge.callHandler('webkit.onPay', postData, function (response) {
        if (
          JSON.parse(response).stateCode == '-1' ||
          JSON.parse(response).stateCode == -1
        ) {
          log.error(response.msg);
          layer.open({ content: response.msg, skin: 'msg', time: 2 });
        }
        if (callback) {
          callback(response);
        }
      });
    } catch (r) {
      console.log('请在app使用');
    }
  },

  AppPayFn(orderString, ThisPayType) {
    // 支付操作，调起app支付SDK
    const currentOS = NissanApi.getOS();
    if (ThisPayType == '2') {
      // 支付宝
      try {
        if (currentOS == 'iOS' || currentOS == 'iPad') {
          console.log('进入IOS支付宝支付方法');
          window.webkit.messageHandlers.payByWeChat_AliPay_App.postMessage({
            orderString,
            payType: ThisPayType,
          });
        } else if (currentOS == 'Android') {
          console.log('进入安卓支付宝支付方法');
          window.webkit.payByWeChat_AliPay_App(ThisPayType, orderString);
        }
      } catch (e) {
        // TODO handle the exception
      }
    } else if (ThisPayType == '1') {
      // 微信
      try {
        if (currentOS == 'iOS' || currentOS == 'iPad') {
          console.log('进入iOS微信支付方法');
          window.webkit.messageHandlers.payByWeChat_AliPay_App.postMessage({
            orderString,
            payType: ThisPayType,
          });
        } else if (currentOS == 'Android') {
          console.log('进入安卓微信支付方法');
          window.webkit.payByWeChat_AliPay_App(ThisPayType, orderString);
        }
      } catch (e) {
        // TODO handle the exception
      }
    }
  },
  AppPayFnResult(callback) {
    window.setPayInfoResultToJD = callback;
  },
};
